class Scrollsmoother {
  static init() {
    const anchors = [...document.querySelectorAll('.hero__onpagenav--a')];
    const anchorElements = [...document.querySelectorAll('.anchorElement')];

    // Click behavior for navigation anchors
    anchors.forEach((anchor) => {
      anchor.onclick = (e) => {
        e.preventDefault();
        const anchorId = anchor.getAttribute('anchorid');
        const targetElement = anchorElements.find((anchorElement) => anchorElement.id === anchorId);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      };
    });

    // Check current URL for a hash and scroll if it matches an element
    const currentHash = window.location.hash;
    if (currentHash) {
      const hashId = currentHash.substring(1); // Remove the '#' character
      const targetElement = anchorElements.find((ele) => ele.id === hashId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }
}

export default Scrollsmoother;
